import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';

export const getDashboardDataRequest = (requestId) => {
    const config = {
        path: `DashboardMassiveService?requestId=${requestId}`,
        method: 'GET'
    };
    return FetchByObjectConfig(config);
}